import React from "react";
import { useLocation, useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex/AdminFormPage";
import ContactForm from "../ContactForm/ContactForm";
import { Contact, ProjectVariable } from "../types/Contact";

const FORM_ID = "contact-form";

interface Props {
  projectId: string;
  permission: string;
  projectStatus: string;
  contacts: Contact[];
  clientId: string | null;
  projectVariableDefinitions: ProjectVariable[];
}

const Edit: React.FC<Props> = ({
  projectId,
  permission,
  projectStatus,
  contacts,
  clientId,
  projectVariableDefinitions,
}) => {
  const navigate = useNavigate();
  const routeLocation = useLocation();
  const contact: Contact = routeLocation.state?.contact;

  const canSave = permission === "manage" && projectStatus === "building";

  return (
    <AdminFormPage
      title="Edit Contact"
      formId={canSave ? FORM_ID : undefined}
      onCancel={() =>
        navigate(`/projects/${projectId}/project_contacts`, {
          state: null,
        })
      }
    >
      <ContactForm
        formId={FORM_ID}
        projectId={projectId}
        contact={contact}
        contacts={contacts}
        clientId={clientId}
        projectVariableDefinitions={projectVariableDefinitions}
      />
    </AdminFormPage>
  );
};

export default Edit;
